import { Col, Row } from 'antd';
import { FormItem } from 'modules/common/components';
import { getIsRequiredInSchema } from 'modules/common/utils/yup/getIsRequiredInSchema';
import { personalInfoFields } from 'modules/owner/components/CreateOwnerProfileForm/PersonalInfoSection/fields';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { personalInfoSchema } from './schema';

type Props = {
  fieldNamePrefix: string;
};

const PersonalInfoFormSection: FC<Props> = ({ fieldNamePrefix }) => {
  const { t } = useTranslation('owner.CreateOwnerPage');
  const { control, formState, getFieldState } = useFormContext();
  const isRequired = getIsRequiredInSchema(personalInfoSchema);
  return (
    <Col span={24}>
      <h2>{t('personalInfo')}</h2>
      {personalInfoFields.map(({ name, Component, label }) => {
        const fieldName = `${fieldNamePrefix}.${name}`;
        const { error } = getFieldState(fieldName, formState);
        const required = isRequired(name);

        return (
          <Row key={fieldName}>
            <Col span={24}>
              <FormItem
                label={label}
                extra={error?.message}
                validateStatus={error ? 'error' : undefined}
                required={required}
              >
                <Component control={control} name={fieldName} />
              </FormItem>
            </Col>
          </Row>
        );
      })}
    </Col>
  );
};

export default PersonalInfoFormSection;
